
import ClipboardJS from 'clipboard-js';

export default function factory() {
  return ClipboardJS;
}
